import Head from 'next/head';
import React from 'react';

const SEOHead = ({ path, lang }) => {
  const locales = ['en', 'ko', 'tw', 'vi'];
  const hostName = 'https://www.design-ac.net';
  const fPath = path ? `/${path}` : '';
  return (
    <Head>
      {lang === 'ja' || lang === 'jp' ? (
        <link rel="canonical" href={`${hostName}${fPath}`} />
      ) : (
        <link rel="canonical" href={`${hostName}/${lang}${fPath}`} />
      )}
      <link rel="alternate" hrefLang="ja" href={`${hostName}${fPath}`} />
      {locales.map((lng) => (
        <link
          key={lng}
          rel="alternate"
          hrefLang={lng}
          href={`${hostName}/${lng}${fPath}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${hostName}${fPath}`}
      ></link>
    </Head>
  );
};

export default SEOHead;
